





    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component({
        name: "balance",
        components: {},
        mixins:[]
    })
    export default class balance extends Vue {
        public created():void {
            // on componenet created
        }
        public mounted():void {
            // on componenet mounted
        }
    }
